// component
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import RoofingRoundedIcon from '@mui/icons-material/RoofingRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Nástenka',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Zakázky',
    path: '/sprava/zakazky',
    icon: <EngineeringRoundedIcon />,
  },
  {
    title: 'Partie',
    path: '/sprava/partie',
    icon: <GroupsRoundedIcon />,
  },
];

export default navConfig;
